export default "__VITE_ASSET__B3bHo3qJ__"